const emitResize = (delay = 100) => {
    let timer = setTimeout(() => {
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            const evt = document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        } else {
            window.dispatchEvent(new Event('resize'));
        }

        clearTimeout(timer);
    }, delay);
};

export default emitResize;



// WEBPACK FOOTER //
// ./src/utils/emitResize.js